import { lazy } from 'react';

export const PlayerUpdateRewardsBlockForm = lazy(
  () => import('./PlayerUpdateRewardsBlockForm'),
);
